import {helpers} from '@/ft-vue-core'
import moment from 'moment'

const {
  simpleCompare,
  forceCurrency,
  escapeHTML
} = helpers

// const PAST_EVENT_MOMENT = moment().subtract(30, 'days')

export default {
  data: function () {
    return {
      locations: [],
      reservationCount: 0,
      reserveeCount: 0,
      noShowCount: 0,
      waitlistedReservees: 0,
      waitlistedReservations: 0,
      didEventFilterDateSelect: false,
      events: [],
      pastEventMoment: moment().subtract(1, 'days')
    }
  },
  computed: {
    emptyRowOptions () {
      const emptyOptions = []
      for (let i = 1; i <= 10; i++) {
        emptyOptions.push({text: i, value: i})
      }
      return [
        {text: 'None', value: 0},
        ...emptyOptions
      ]
    },
    groupedByReservation () {
      // override to enable
      return false
    },
    hasSelectedEvents () {
      return this.reportFilters.eventNames && this.reportFilters.eventNames[0]
    },
    selectedEvents () {
      const eventNames = this.reportFilters.eventNames || []
      const dates = this.reportFilters.dates || []
      const events = this.events || []
      return events.filter(e => eventNames.indexOf(e.name) && (!dates[0] || dates.indexOf(e.date)))
    },
    selectedEventsDateList () {
      if (this.hasSelectedEvents) {
        const eventIds = this.getSelectedEventIds(this.reportFilters)
        const found = {}
        var d
        var key
        return this.events.reduce((acc, e) => {
          key = e.date
          if (!found[key] && eventIds.find(eId => eId === e.id)) {
            d = {value: key, text: key, cancelled: e.cancelled}
            acc.push(d)
            found[key] = d
          } else if (found[key] && !e.cancelled) {
            found[key].cancelled = false
          }
          return acc
        }, []).sort((a, b) => simpleCompare(a.value, b.value))
      } else {
        return []
      }
    },
    currentEventsDateList () {
      return this.selectedEventsDateList.filter(d => moment(d.value).isSameOrAfter(this.pastEventMoment) && !d.cancelled)
    },
    pastEventsDateList () {
      return this.selectedEventsDateList.filter(d => moment(d.value).isBefore(this.pastEventMoment) && !d.cancelled)
    },
    cancelledEventsDateList () {
      return this.selectedEventsDateList.filter(d => d.cancelled)
    },
    groupedEventsDateList () {
      const currentEventsDateList = this.currentEventsDateList
      const pastEventsDateList = this.pastEventsDateList
      const cancelledEventsDateList = this.cancelledEventsDateList
      return [
        ...currentEventsDateList.length ? [{header: 'Current'}] : [],
        ...currentEventsDateList,
        ...pastEventsDateList.length ? [{divider: true}, {header: 'Past'}] : [],
        ...pastEventsDateList.sort((a, b) => simpleCompare(b.value, a.value)),
        ...cancelledEventsDateList.length ? [{divider: true}, {header: 'Canceled'}] : [],
        ...cancelledEventsDateList.sort((a, b) => simpleCompare(b.value, a.value))
      ]
    },
    eventsOnly () {
      return true
    },
    filteredLocations () {
      const eventIds = this.getSelectedEventIds(this.reportFilters)
      if (!this.eventsOnly || !eventIds.length) return this.locations
      return this.locations.filter(l => eventIds.find(eId => ((this.eventMap[eId] || {}).locations || []).find(el => el.locationId === l.id)))
    },
    uniqueEvents () {
      const found = {}
      return this.events.filter(e => {
        const key = e.name
        if (found[key]) return false
        found[key] = true
        return true
      })
    },
    selectedLocationIdsMap () {
      return this.reportFilters.locationIds ? this.reportFilters.locationIds.reduce((a, v) => {
        a[v] = v
        return a
      }, {}) : {}
    },
    selectableEvents () {
      return this.events.filter(e => {
        if (this.selectedLocationIdsMap && this.reportFilters.locationIds && this.reportFilters.locationIds[0]) {
          const slm = this.selectedLocationIdsMap
          if (!e.locations.find(l => slm[l.locationId])) return false
        }
        if (this.reportFilters.date) {
          return moment(this.reportFilters.date).isSame(e.date, 'day')
        }
        return true
      })
    },
    uniqueSelectableEvents () {
      const found = {}
      return this.selectableEvents.filter(e => {
        const key = e.name
        const fe = found[key]
        if (fe) {
          if (!fe.__relatedEventMap[e.id]) {
            fe.__relatedEventMap[e.id] = e
            fe.__relatedEvents.push(e)
          }
          return false
        }
        if (!e.__relatedEvents) {
          Object.defineProperty(e, '__isCurrent', {value: undefined, writable: true})
          Object.defineProperty(e, '__relatedEventMap', {value: undefined, writable: true})
          Object.defineProperty(e, '__relatedEvents', {value: undefined, writable: true})
          e.__relatedEventMap = {}
          e.__relatedEvents = []
          e.__relatedEventMap[e.id] = e
          e.__relatedEvents.push(e)
        }
        found[key] = e
        return true
      })
    },
    currentSelectableEvents () {
      return this.uniqueSelectableEvents.filter(e => this.isCurrentEvent(e))
    },
    pastSelectableEvents () {
      return this.uniqueSelectableEvents.filter(e => !this.isCurrentEvent(e))
    },
    groupedSelectableEvents () {
      const currentSelectableEvents = this.currentSelectableEvents
      const pastSelectableEvents = this.pastSelectableEvents
      return [
        ...currentSelectableEvents.length ? [{header: 'Current'}] : [],
        ...currentSelectableEvents,
        ...pastSelectableEvents.length ? [{divider: true}, {header: 'Past'}] : [],
        ...pastSelectableEvents.slice().sort((a, b) => simpleCompare(b.value, a.value))
      ]
    },
    selectedEventFilterDate () {
      return this.reportFilters.date
    },
    selectedEventNames () {
      return this.reportFilters.eventNames
    },
    eventMap () {
      return this.events.reduce((result, item) => {
        result[item.id] = item
        return result
      }, {})
    },
    detailGroupingOptions () {
      // Override this computed to filter/add others
      return this.baseDetailGroupingOptions
    },
    baseDetailGroupingOptions () {
      return [
        {
          id: 1,
          name: 'All Reservees w/o Grouping',
          subTitle: 'Reservees'
        },
        {
          id: 2,
          name: 'All Reservees Group by Reservation',
          subTitle: 'Reservations',
          groupByReservation: true,
          group: [
            {
              by: ['reservationId'],
              newBody: true,
              bodyClass: ['ft-report-flat-group']
            }
          ],
          fields: ['reservationId', 'pos', 'id']
        },
        {
          id: 3,
          name: 'Consolidated Reservations',
          subTitle: 'Reservations',
          consolidated: true,
          group: [
            {
              by: ['reservationId'],
              newBody: true,
              bodyClass: ['ft-report-flat-group']
            }
          ]
        }
      ]
    },
    sortOptionMap () {
      return this.sortOptions.reduce((result, item) => {
        result[item.id] = item
        return result
      }, {})
    },
    sortOptions () {
      // Override this computed to filter/add others
      return this.baseSortOptions
    },
    baseSortOptions () {
      return [
        {
          id: 1,
          name: 'Reservation',
          order: ['reservationId:ASC', 'pos:ASC']
        },
        {
          id: 2,
          name: 'Last Name',
          order: ['name:ASC_NULLS_LAST']
        },
        {
          id: 3,
          name: 'Time',
          order: ['dateTime:ASC', 'reservationId:ASC', 'pos:ASC']
        },
        {
          id: 4,
          name: 'Date/Time Taken',
          order: ['reservationCreated:ASC', 'reservationId:ASC', 'pos:ASC']
        },
        {
          id: 5,
          name: 'Date/Time Updated',
          order: ['reservationUpdated:ASC', 'reservationId:ASC', 'pos:ASC']
        },
        {
          id: 6,
          name: 'Check Number',
          order: ['reservationId:ASC', 'pos:ASC', 'checkNumber:ASC']
        },
        {
          id: 7,
          name: 'Occasion',
          order: ['occasionName:ASC', 'reservationId:ASC', 'pos:ASC']
        },
        {
          id: 8,
          name: 'Table Number',
          order: ['tableNumber:ASC', 'reservationId:ASC', 'pos:ASC']
        }
      ]
    },
    baseColumnOptions () {
      return [
        {
          id: 1,
          name: 'Reservation #',
          fields: ['reservationId'],
          column: {
            text: '#',
            field: 'reservationId',
            displayCell: (row, rowIndex, cellIndex, rows) => this.reservationChanged(row, rowIndex, rows) ? row.reservationId : null
          },
          optional: false
        },
        {
          id: 16,
          name: 'Reservee Position',
          fields: ['pos'],
          column: {text: 'Position', field: 'pos'},
          optional: true
        },
        {
          id: 2,
          name: 'Reservee Name',
          fields: ['name', 'guestTypeName', 'guestTypeId', 'isTbd', 'discreteCovers', 'pos', 'covers'],
          column: {
            text: 'Reservee',
            field: 'names',
            displayCell: (row, rowIndex, cellIndex, rows) => {
              if (!row) return [{}]
              return this.consolidateDetails
                ? this.getNameListFromDetails(row, rowIndex, rows)
                : [{name: this.getNameFromItem(row), guestType: row.guestTypeName || null}]
            },
            slot: true // Will use template override for display, not ReportBuilder default
          },
          optional: true
        },
        {
          id: 51,
          name: 'Last Name',
          fields: ['nameLast'],
          column: {
            text: 'Last Name',
            field: 'nameLast'
          },
          optional: true
        },
        {
          id: 52,
          name: 'First Name',
          fields: ['nameFirst'],
          column: {
            text: 'First Name',
            field: 'nameFirst'
          },
          optional: true
        },
        {
          id: 3,
          name: 'Member # / Guest Type',
          fields: ['memberNumber', 'guestTypeName', 'isTbd'],
          column: {
            text: 'Mem # / Guest Type',
            field: 'memberNumberGuestType',
            displayCell: (row, rowIndex, cellIndex, rows) => row.memberNumber || row.guestTypeName
          },
          optional: true
        },
        {
          id: 19,
          name: 'Member #',
          fields: ['memberNumber'],
          column: {
            text: 'Mem #',
            field: 'memberNumber'
          },
          optional: true
        },
        {
          id: 49,
          name: 'Member Type',
          fields: ['mType'],
          column: {
            text: 'Member Type',
            field: 'mType_c',
            displayCell: (row, rowIndex, cellIndex) => {
              if (this.selectedDetailGrouping.consolidated) {
                const relatedCount = row._related.length
                return this.consolidateColumn(row._related, 'mType')
                  .map(c => c.name + (relatedCount > 1 ? ' (' + c.total + ')' : ''))
                  .join(', ')
              }
              return row.mType
            },
            aggregateDefault: () => [],
            aggregate: (aggregate, row, rowIndex) => {
              if (this.selectedDetailGrouping.consolidated) {
                this.consolidateColumn(row._related).forEach(c => this.aggregateColumn(aggregate, c.name, c.total))
                return aggregate
              }
              return this.aggregateColumn(aggregate, row.mType, row.mType ? 1 : 0)
            },
            displayAggregate: (aggregate, row, rowIndex, rows) => aggregate,
            aggregateSlot: true,
            slotName: 'explodeAggregate'
          },
          optional: true
        },
        {
          id: 50,
          name: 'Membership',
          fields: ['mShip'],
          column: {
            text: 'Membership',
            field: 'mShip_c',
            displayCell: (row, rowIndex, cellIndex) => {
              if (this.selectedDetailGrouping.consolidated) {
                const relatedCount = row._related.length
                return this.consolidateColumn(row._related, 'mShip')
                  .map(c => c.name + (relatedCount > 1 ? ' (' + c.total + ')' : ''))
                  .join(', ')
              }
              return row.mShip
            },
            aggregateDefault: () => [],
            aggregate: (aggregate, row, rowIndex) => {
              if (this.selectedDetailGrouping.consolidated) {
                this.consolidateColumn(row._related).forEach(c => this.aggregateColumn(aggregate, c.name, c.total))
                return aggregate
              }
              return this.aggregateColumn(aggregate, row.mShip, row.mShip ? 1 : 0)
            },
            displayAggregate: (aggregate, row, rowIndex, rows) => aggregate,
            aggregateSlot: true,
            slotName: 'explodeAggregate'
          },
          optional: true
        },
        {
          id: 20,
          name: 'Guest Type',
          fields: ['guestTypeName'],
          column: {
            text: 'Guest Type',
            field: 'guestTypeName'
          },
          optional: true
        },
        {
          id: 4,
          name: 'Total Covers',
          fields: ['covers', 'waitlist', 'noShows', 'noShow'],
          column: {
            text: 'Covers',
            field: 'covers',
            displayCell: (row, rowIndex, cellIndex, rows) => row.waitlist ? null : this.reservationChanged(row, rowIndex, rows) ? row.covers - row.noShows : null,
            aggregateDefault: 0,
            aggregate: (aggregate, row, rowIndex, rows) => aggregate + (row.waitlist ? 0 : this.isConsolidated(row) ? row.covers - row.noShows : row.noShow ? 0 : 1),
            displayAggregate: (aggregate, row, rowIndex, rows) => aggregate,
            aggregateSlot: false
          },
          optional: true
        },
        {
          id: 29,
          name: 'Cover / Total',
          fields: ['covers', 'showPos', 'waitlist', 'noShows', 'noShow'],
          column: {
            text: 'Covers',
            field: 'covers_total',
            displayCell: (row, rowIndex, cellIndex, rows) => row.waitlist ? '' : this.isConsolidated(row) ? row.covers - row.noShows + ' / ' + row.covers : (row.noShow ? 0 : row.showPos + 1) + ' / ' + row.covers,
            aggregateDefault: () => 0,
            aggregate: (aggregate, row, rowIndex, rows) => aggregate + (row.waitlist ? 0 : this.isConsolidated(row) ? row.covers - row.noShows : row.noShow ? 0 : 1),
            displayAggregate: (aggregate, row, rowIndex, rows) => aggregate
          },
          optional: true
        },
        {
          id: 54,
          name: 'Walk-Ins Res.',
          fields: ['walkIn', 'waitlist'],
          column: {
            text: 'Walk-Ins',
            field: 'walkInRes',
            displayCell: (row, rowIndex, cellIndex, rows) => row.waitlist || row.pos > 0 ? '' : row.walkIn ? 1 : '',
            aggregateDefault: () => 0,
            aggregate: (aggregate, row, rowIndex, rows) => aggregate + (row.waitlist || row.pos > 0 ? 0 : row.walkIn ? 1 : 0),
            displayAggregate: (aggregate, row, rowIndex, rows) => aggregate
          },
          optional: true
        },
        {
          id: 55,
          name: 'Walk-Ins Covers',
          fields: ['walkIn', 'waitlist'],
          column: {
            text: 'Walk-Ins',
            field: 'walkInCovers',
            displayCell: (row, rowIndex, cellIndex, rows) => row.waitlist ? '' : row.walkIn ? this.isConsolidated(row) ? row.covers : 1 : '',
            aggregateDefault: () => 0,
            aggregate: (aggregate, row, rowIndex, rows) => aggregate + (row.waitlist ? 0 : row.walkIn ? this.isConsolidated(row) ? row.covers : 1 : 0),
            displayAggregate: (aggregate, row, rowIndex, rows) => aggregate
          },
          optional: true
        },
        {
          id: 48,
          name: 'Wait-Listed',
          fields: ['covers', 'waitlist'],
          column: {
            text: 'Wait-Listed',
            field: 'waitlisted',
            displayCell: (row, rowIndex, cellIndex, rows) => !row.waitlist ? null : this.reservationChanged(row, rowIndex, rows) ? row.covers : null,
            aggregateDefault: 0,
            aggregate: (aggregate, row, rowIndex, rows) => aggregate + (!row.waitlist ? 0 : this.isConsolidated(row) ? row.covers : 1),
            displayAggregate: (aggregate, row, rowIndex, rows) => aggregate,
            aggregateSlot: false
          },
          optional: true
        },
        {
          id: 47,
          name: 'No-Show',
          fields: ['noShow', 'noShows', 'waitlist'],
          column: {
            text: 'No-Show',
            field: 'no_show',
            displayCell: (row, rowIndex, cellIndex, rows) => row.waitlist ? '' : this.isConsolidated(row) ? row.noShows || '' : row.noShow ? 1 : '',
            aggregateDefault: () => 0,
            aggregate: (aggregate, row, rowIndex, rows) => aggregate + (row.waitlist ? 0 : this.isConsolidated(row) ? row.noShows : row.noShow ? 1 : 0),
            displayAggregate: (aggregate, row, rowIndex, rows) => aggregate
          },
          optional: true
        },
        {
          id: 5,
          name: 'Check #',
          fields: ['checkNumber'],
          column: {
            text: 'Check #',
            field: 'checkNumber',
            displayCell: (row, rowIndex, cellIndex, rows) => {
              if (!row) return null
              const found = {}
              return this.selectedDetailGrouping.consolidated ? row._related.reduce((a, r) => {
                const checkNum = r.checkNumber
                if (checkNum && !found[checkNum]) {
                  found[checkNum] = true
                  a.push(checkNum)
                }
                return a
              }, []).join(', ') : row.checkNumber
            }
          },
          optional: true
        },
        {
          id: 27,
          name: 'Table #',
          fields: ['tableNumber'],
          column: {text: 'Table #', field: 'tableNumber'},
          optional: true
        },
        {
          id: 17,
          name: 'Location',
          fields: ['locationName'],
          column: {text: 'Location', field: 'locationName'},
          optional: true
        },
        {
          id: 30,
          name: 'Event',
          fields: ['eventName'],
          column: {text: 'Event', field: 'eventName'},
          optional: true
        },
        {
          id: 31,
          name: 'Event Charges (Consolidated)',
          fields: ['eventCostName', 'covers', 'eventCostId', 'waitlist'],
          column: {
            text: 'Charge',
            field: 'eventCostName',
            displayCell: (row, rowIndex, cellIndex) => {
              if (!row.discreteCovers) {
                return row.covers > 1 ? row.eventCostName + ' (' + row.covers + ')' : row.eventCostName
              }
              if (this.selectedDetailGrouping.consolidated) {
                const relatedCount = row._related.length
                return this.consolidateCosts(row._related)
                  .map(c => c.name + (relatedCount > 1 ? ' (' + c.total + ')' : ''))
                  .join(', ')
              }
              return row.eventCostName
            },
            aggregateDefault: () => [],
            aggregate: (aggregate, row, rowIndex) => {
              if (!row.discreteCovers) return this.aggregateCosts(aggregate, row.eventCostName, row.covers)
              if (this.selectedDetailGrouping.consolidated) {
                this.consolidateCosts(row._related).forEach(c => this.aggregateCosts(aggregate, c.name, c.total))
                return aggregate
              }
              return this.aggregateCosts(aggregate, row.eventCostName, 1)
            },
            displayAggregate: (aggregate, row, rowIndex, rows) => aggregate,
            aggregateSlot: true
          },
          optional: true
        },
        {
          id: 32,
          name: 'Event Charges (Per-Column)',
          fields: ['eventCostName', 'covers', 'eventCostId', 'waitlist'],
          vColumns: [],
          vColumnSort: (a, b) => a.text.toLowerCase().localeCompare(b.text.toLowerCase()),
          buildVColumnFromRow: (row, columns, vColumnLookup) => {
            const key = row.eventCostName
            if (!key) return columns
            var vCol = vColumnLookup[key]
            if (!vCol) {
              vCol = {
                text: row.eventCostName,
                field: key,
                displayCell: (row, rowIndex, cellIndex, rows, group, header) => {
                  if (!row.discreteCovers) {
                    return row.eventCostName === key ? row.covers : ''
                  }
                  if (this.selectedDetailGrouping.consolidated) {
                    var consolidateCosts = row._consolidateCosts
                    if (!consolidateCosts) {
                      consolidateCosts = this.consolidateCosts(row._related)
                      row._consolidateCosts = consolidateCosts
                    }
                    const match = consolidateCosts.find(c => c.name === key)
                    return match ? match.total : ''
                  }
                  return row.eventCostName === key ? 1 : ''
                },
                aggregateDefault: () => 0,
                aggregate: (aggregate, row, rowIndex, rows, header) => {
                  if (!row.discreteCovers) {
                    aggregate += row.eventCostName === key ? row.covers : 0
                  } else if (this.selectedDetailGrouping.consolidated) {
                    var consolidateCosts = row._consolidateCosts
                    if (!consolidateCosts) {
                      consolidateCosts = this.consolidateCosts(row._related)
                      row._consolidateCosts = consolidateCosts
                    }
                    const match = consolidateCosts.find(c => c.name === key)
                    aggregate += match ? match.total : 0
                  } else {
                    aggregate += row.eventCostName === key ? 1 : 0
                  }
                  return aggregate
                },
                displayAggregate: (aggregate, row, rowIndex, rows) => aggregate || ''
              }
              vColumnLookup[key] = vCol
              columns.push(vCol)
            }
            return columns
          },
          optional: true
        },
        {
          id: 41,
          name: 'Event Price',
          fields: ['eventCostPrice', 'covers', 'waitlist'],
          column: {
            text: 'Event Price',
            field: 'eventCostPrice',
            displayCell: (row, rowIndex, cellIndex, rows) => {
              const result = this.isConsolidated(row) ? this.getEventPrice(row) * row.covers : this.getEventPrice(row)
              return result ? '$' + forceCurrency(result) : ''
            },
            aggregateDefault: () => 0,
            aggregate: (aggregate, row, rowIndex, rows) => aggregate + (this.isConsolidated(row) ? this.getEventPrice(row) * row.covers : this.getEventPrice(row)),
            displayAggregate: (aggregate, row, rowIndex, rows) => '$' + forceCurrency(aggregate || 0)
          },
          optional: true
        },
        {
          id: 33,
          name: 'Reservation Q/A',
          fields: ['reservationAnswers'],
          vColumns: [],
          // vColumnSort: (a, b) => a.text.toLowerCase().localeCompare(b.text.toLowerCase()),
          buildVColumnFromRow: (row, columns, vColumnLookup) => {
            for (let answer of row.reservationAnswers) {
              this.buildVColumnFromAnswer(answer, row, columns, vColumnLookup, true)
            }
            return columns
          },
          optional: true
        },
        {
          id: 34,
          name: 'Reservee Q/A',
          fields: ['answers'],
          vColumns: [],
          // vColumnSort: (a, b) => a.text.toLowerCase().localeCompare(b.text.toLowerCase()),
          buildVColumnFromRow: (row, columns, vColumnLookup) => {
            for (let answer of row.answers) {
              this.buildVColumnFromAnswer(answer, row, columns, vColumnLookup, false)
            }
            return columns
          },
          optional: true
        },
        {
          id: 18,
          name: 'Meal Period',
          fields: ['mealPeriodName'],
          column: {text: 'Meal Period', field: 'mealPeriodName'},
          optional: true
        },
        {
          id: 6,
          name: 'Occasion',
          fields: ['occasionName'],
          column: {text: 'Occasion', field: 'occasionName'},
          optional: true
        },
        {
          id: 8,
          name: 'Special Preferences',
          fields: ['memberSpecialRequests'],
          column: {
            text: 'Special Preferences',
            field: 'memberSpecialRequests',
            displayCell: (row, rowIndex, cellIndex, rows) => {
              return this.isConsolidated(row) ? this.groupDetailColumns(row._related, 'memberSpecialRequests').join('; ') : row.memberSpecialRequests
            }
          },
          optional: true
        },
        {
          id: 11,
          name: 'Food Preference',
          fields: ['foodPreference'],
          column: {
            text: 'Food Preference',
            field: 'foodPreference',
            displayCell: (row, rowIndex, cellIndex, rows) => {
              return this.isConsolidated(row) ? this.groupDetailColumns(row._related, 'foodPreference').join('; ') : row.foodPreference
            }
          },
          optional: true
        },
        {
          id: 12,
          name: 'Cocktail Preference',
          fields: ['drinkPreference'],
          column: {
            text: 'Cocktail Preference',
            field: 'drinkPreference',
            displayCell: (row, rowIndex, cellIndex, rows) => {
              return this.isConsolidated(row) ? this.groupDetailColumns(row._related, 'drinkPreference').join('; ') : row.drinkPreference
            }
          },
          optional: true
        },
        {
          id: 13,
          name: 'Allergy Information',
          fields: ['allergyInformation'],
          column: {
            text: 'Allergies',
            field: 'allergyInformation',
            displayCell: (row, rowIndex, cellIndex, rows) => {
              return this.isConsolidated(row) ? this.groupDetailColumns(row._related, 'allergyInformation').join('; ') : row.allergyInformation
            }
          },
          optional: true
        },
        {
          id: 14,
          name: 'Phone Number',
          fields: ['phone'],
          column: {
            text: 'Phone Number',
            field: 'phone',
            displayCell: (row, rowIndex, cellIndex, rows) => {
              return this.isConsolidated(row) ? this.groupDetailColumns(row._related, 'phone').join('; ') : row.phone
            }
          },
          optional: true
        },
        {
          id: 15,
          name: 'Email Address',
          fields: ['email'],
          column: {
            text: 'Email Address',
            field: 'email',
            displayCell: (row, rowIndex, cellIndex, rows) => {
              return this.isConsolidated(row) ? this.groupDetailColumns(row._related, 'email').join('; ') : row.email
            }
          },
          optional: true
        },
        {
          id: 56,
          name: 'Birthday',
          fields: ['birthday'],
          column: {
            text: 'Birthday',
            field: 'birthday',
            displayCell: (row, rowIndex, cellIndex, rows) => {
              return this.isConsolidated(row) ? this.groupDetailColumns(row._related, 'birthday').join('; ') : row.birthday
            }
          },
          optional: true
        },
        {
          id: 20,
          name: 'Reservee Updated',
          fields: ['updated'],
          column: {text: 'Reservee Updated', field: 'updated'},
          optional: true
        },
        {
          id: 21,
          name: 'Reservee Created',
          fields: ['created'],
          column: {text: 'Reservee Created', field: 'created'},
          optional: true
        },
        {
          id: 22,
          name: 'Reservation Updated',
          fields: ['reservationUpdated'],
          column: {text: 'Reservation Updated', field: 'reservationUpdated', type: 'DATE_TIME'},
          optional: true
        },
        {
          id: 23,
          name: 'Reservation Created',
          fields: ['reservationCreated'],
          column: {text: 'Reservation Created', field: 'reservationCreated', type: 'DATE_TIME'},
          optional: true
        },
        {
          id: 24,
          name: 'Reservation Date/Time',
          fields: ['dateTime'],
          column: {text: 'Date/Time', field: 'dateTime', type: 'DATE_TIME'},
          optional: true
        },
        {
          id: 25,
          name: 'Reservation Date',
          fields: ['date'],
          column: {text: 'Date', field: 'date', type: 'DATE'},
          optional: true
        },
        {
          id: 26,
          name: 'Reservation Time',
          fields: ['time'],
          column: {text: 'Time', field: 'time', type: 'TIME'},
          optional: true
        },
        {
          id: 9,
          name: 'Member Requests',
          fields: ['reservationSpecialRequests'],
          column: {text: 'Member Requests', field: 'reservationSpecialRequests', spanGroup: this.groupedByReservation},
          optional: true
        },
        {
          id: 7,
          name: 'Hidden Requests',
          fields: ['specialRequests'],
          column: {text: 'Hidden Requests', field: 'specialRequests', spanGroup: this.groupedByReservation},
          optional: true
        },
        {
          id: 53,
          name: 'Hidden & Member Requests',
          fields: ['specialRequests', 'reservationSpecialRequests'],
          column: {
            text: 'All Requests',
            field: 'specialRequests',
            spanGroup: this.groupedByReservation,
            displayCell: (row, rowIndex, cellIndex, rows) => {
              var result = ''
              if (row.specialRequests) result += row.specialRequests
              if (row.reservationSpecialRequests) {
                if (result) result += '; '
                result += row.reservationSpecialRequests
              }
              return result
            }
          },
          optional: true
        },
        {
          id: 28,
          name: 'Tables',
          fields: ['tables', 'covers'], // Uses cover counts for row span in display
          column: {
            text: 'Tables',
            field: 'tables',
            spanGroup: this.groupedByReservation,
            displayHtml: row => {
              if (!row.tables) return null
              var result = ''
              for (let table of row.tables) {
                result += '<span><span>(' + table.quantity + ')</span><b>' + escapeHTML(table.locationTableName) + '</b></span>'
                if (table.notes) {
                  result += '<i>&mdash;' + escapeHTML(table.notes) + '</i>'
                }
              }
              return result
            },
            cellClass: (row, rowIndex, columnIndex, rows) => {return 'ft-table-asmt'}
          },
          optional: true
        },
        /*
        {
          id: 46,
          name: 'Table Notes',
          fields: ['tables', 'covers'], // Uses cover counts for row span in display
          column: {
            text: 'Table Notes',
            field: 'table-notes',
            displayHtml: (row, rowIndex, cellIndex, rows) => {
              if (!row.tables) return null
              var result = ''
              for (let table of row.tables) {
                if (table.notes) {
                  result += '<div class="ft-report-table-note">' + escapeHTML(table.notes) + '</div>'
                }
              }
              return result
            },
            spanGroup: this.groupedByReservation
          },
          optional: true
        }, */
        {
          id: 10,
          name: 'Confirmation Notes',
          fields: ['confirmationNotes'],
          column: {text: 'Confirmation Notes', field: 'confirmationNotes', spanGroup: this.groupedByReservation},
          optional: true
        },
        {
          id: 35,
          name: 'Confirmation Status',
          fields: ['confirmationStatusName'],
          column: {text: 'Confirmation Status', field: 'confirmationStatusName', spanGroup: this.groupedByReservation},
          optional: true
        },
        {
          id: 36,
          name: 'Cancellation Date/Time',
          fields: ['cancelled'],
          column: {text: 'Canceled Date/Time', field: 'cancelled', type: 'DATE_TIME'},
          optional: true
        },
        {
          id: 37,
          name: 'Canceled By',
          fields: ['cancelledByFullName'],
          column: {text: 'Canceled By', field: 'cancelledByFullName'},
          optional: true
        },
        {
          id: 44,
          name: 'Cancel Fees Apply On',
          fields: ['cancelByDateTime'],
          column: {text: 'Cancel Fees Apply On', field: 'cancelByDateTime', type: 'DATE_TIME'},
          optional: true
        },
        {
          id: 38,
          name: 'Cancellation Reason',
          fields: ['cancellationReason'],
          column: {text: 'Cancellation Reason', field: 'cancellationReason'},
          optional: true
        },
        {
          id: 39,
          name: 'Cancellation Notes',
          fields: ['cancellationNotes'],
          column: {text: 'Cancellation Notes', field: 'cancellationNotes'},
          optional: true
        },
        {
          id: 40,
          name: 'Cancel Fee Exempt',
          fields: ['cancelFeeExempt'],
          column: {text: 'Cancel Fee Exempt', field: 'cancelFeeExempt', type: 'FLAG'},
          optional: true
        },
        {
          id: 45,
          name: 'Cancel Fee Applies',
          fields: ['cancelFeeExempt', 'cancellationChargeApplies'],
          column: {text: 'Cancel Fee Applies', field: 'cancelFeeApplies', displayCell: row => row.cancellationChargeApplies && !row.cancelFeeExempt, type: 'FLAG'},
          optional: true
        },
        /* This one could be confusing.  This is what a cancellation charge /would/ be, the cancellation isn't exempt. */
        /*
        {
          id: 42,
          name: 'Cancellation Charge',
          fields: ['cancellationCharge'],
          column: {
            text: 'Cancellation Charge',
            field: 'cancellationCharge',
            displayCell: (row, rowIndex, cellIndex, rows) => {
              const result = this.isConsolidated(row) ? this.getCancellationCharge(row) : this.getCancellationCharges(rows)
              return result ? result + '$' + forceCurrency(result) : ''
            }
          },
          optional: true
        },
        */
        {
          id: 43,
          name: 'Cancel Fee',
          fields: ['cancelFeeExempt', 'cancellationChargeApplies', 'cancellationCharge', 'covers', 'waitlist'],
          column: {
            text: 'Cancellation Fee',
            field: 'cancellationChargeIfApplies',
            displayCell: (row, rowIndex, cellIndex, rows) => {
              const result = this.isConsolidated(row) ? this.getCancellationChargeIfApplies(row) * row.covers : this.getCancellationChargeIfApplies(row)
              return result ? '$' + forceCurrency(result) : ''
            },
            aggregateDefault: () => 0,
            aggregate: (aggregate, row, rowIndex, rows) => aggregate + (this.isConsolidated(row) ? this.getCancellationChargeIfApplies(row) * row.covers : this.getCancellationChargeIfApplies(row)),
            displayAggregate: (aggregate, row, rowIndex, rows) => '$' + forceCurrency(aggregate || 0)
          },
          optional: true
        }
      ]
    }
  },
  methods: {
    setPastEventMoment () {
      this.pastEventMoment = moment().subtract(this.$ftCS.DINING_REPORT_KEEP_PAST_EVENTS_CURRENT, 'days')
    },
    allEventDatesCancelled (event) {
      return !this.events.find(e => e.name === event.name && !e.cancelled)
    },
    isCurrentEvent (e) {
      if (e.__isCurrent === undefined) {
        e.__isCurrent = e.__relatedEvents.find(fe => moment(fe.startDateTime).isSameOrAfter(this.pastEventMoment)) || null
      }
      return e.__isCurrent
    },
    getDefaultIncludeFields () {
      return ['covers', 'waitlist', 'noShows', 'name', 'guestTypeName', 'guestTypeId', 'isTbd', 'discreteCovers', 'pos']
    },
    isConsolidated (row) {
      return !row.discreteCovers || this.selectedDetailGrouping.consolidated
    },
    getCancellationCharges (rows) {
      var result = 0
      rows.forEach(r => {result += this.getCancellationCharge(r)})
      return result
    },
    getCancellationCharge (row) {
      return row.cancellationCharge || 0
    },
    getCancellationChargesIfApplies (rows) {
      var result = 0
      rows.forEach(r => {result += this.getCancellationChargeIfApplies(r)})
      return result
    },
    getCancellationChargeIfApplies (row) {
      return !row.waitlist && row.cancellationChargeApplies && !row.cancelFeeExempt ? row.cancellationCharge || 0 : 0
    },
    getEventPrices (rows) {
      var result = 0
      rows.forEach(r => {result += this.getEventPrice(r)})
      return result
    },
    getEventPrice (row) {
      return !row.waitlist ? row.eventCostPrice || 0 : 0
    },
    getSelectedEventIds (f) {
      if (!f.eventNames || !f.eventNames.length) return []
      const eventIds = this.events.reduce((acc, e) => {
        if (f.eventNames.find(en => en === e.name)) {
          acc.push(e.id)
        }
        return acc
      }, [])
      return eventIds
    },
    getSelectedDatesFilter (f) {
      const dateFilters = []
      if (f.dates && f.dates.length) {
        for (let d of f.dates) {
          dateFilters.push({
            condition: 'OR',
            field: 'dateTime',
            operator: 'BETWEEN',
            values: [
              d + ' 00:00:00',
              d + ' 23:59:59'
            ]
          })
        }
      }
      return dateFilters
    },
    buildVColumnFromAnswer (answer, row, columns, vColumnLookup, entireReservation) {
      const answerField = entireReservation ? 'reservationAnswers' : 'answers'
      function _buildKey (q) {
        return q + '__' + (entireReservation ? 'r' : 'pr')
      }
      const key = _buildKey(answer.question)
      if (!key) return columns
      var vCol = vColumnLookup[key]
      if (!vCol) {
        vCol = {
          text: answer.question,
          field: key,
          spanGroup: this.groupedByReservation && entireReservation,
          displayCell: (row, rowIndex, cellIndex, rows, group, header) => {
            if (!entireReservation && !row.discreteCovers) return '' // Only discreteCovers have answers per reservee
            if (!entireReservation && this.selectedDetailGrouping.consolidated) {
              var consolidateQuestionLookup = this.consolidatedQuestionLookup(row, row._related, answerField, _buildKey)
              const match = consolidateQuestionLookup[key]
              return match ? match.map(a => a.value + ' (' + a.total + ')').join(', ') : ''
            }
            const questionLookup = this.questionLookup(row, row[answerField], _buildKey)
            const answer = questionLookup[key]
            return answer ? answer.value : ''
          },
          aggregateDefault: () => [],
          aggregate: (aggregate, row, rowIndex, rows, header) => {
            if (!entireReservation && !row.discreteCovers) {
              return aggregate // Only discreteCovers have answers per reservee
            }
            var answerLookup = aggregate._answerLookup
            if (!answerLookup) {
              answerLookup = {}
              aggregate._answerLookup = answerLookup
            }
            if (!entireReservation && this.selectedDetailGrouping.consolidated) {
              var consolidateQuestionLookup = this.consolidatedQuestionLookup(row, row._related, answerField, _buildKey)
              const answers = consolidateQuestionLookup[key]
              if (answers) {
                for (let answer of answers) {
                  this.getAnswerAggregate(aggregate, answer)
                }
              }
            } else if (!entireReservation || row.pos === 0) {
              const questionLookup = this.questionLookup(row, row[answerField], _buildKey)
              const answer = questionLookup[key]
              if (answer) {
                this.getAnswerAggregate(aggregate, answer)
              }
            }
            return aggregate
          },
          displayAggregate: (aggregate, row, rowIndex, rows) => aggregate || '',
          aggregateSlot: true,
          slotName: 'explodeAnswers'
        }
        vColumnLookup[key] = vCol
        columns.push(vCol)
      }
      return columns
    },
    getAnswerAggregate (aggregate, answer) {
      const key = answer.value
      const lookup = aggregate._answerLookup
      var answerAggregate = lookup[key]
      if (!answerAggregate) {
        answerAggregate = {
          value: answer.value,
          total: 0,
          fromList: 0
        }
        lookup[key] = answerAggregate
        aggregate.push(answerAggregate)
      }
      answerAggregate.total += answer.total
      answerAggregate.fromList += answer.fromList
      return answerAggregate
    },
    consolidatedQuestionLookup (row, details, answerField, _buildKey) {
      const lookupKey = _buildKey('__consolidatedQuestionLookup')
      var consolidatedLookup = row[lookupKey]
      if (!consolidatedLookup) {
        const questionAnswerLookup = {}
        consolidatedLookup = details.reduce((a, detail) => {
          return detail[answerField].reduce((a, answer) => {
            const key = _buildKey(answer.question)
            const vKey = key + '~:~' + answer.value
            var answers = questionAnswerLookup[vKey]
            if (!answers) {
              answers = {
                value: answer.value,
                total: 0,
                fromList: 0
              }
              questionAnswerLookup[vKey] = answers
              var answerArray = a[key]
              if (!answerArray) {
                answerArray = []
                answerArray._answerLookup = {}
                a[key] = answerArray
              }
              answerArray._answerLookup[answer.value] = answers
              answerArray.push(answers)
            }
            answers.total ++
            answers.fromList += answer.fromList ? 1 : 0
            return a
          }, a)
        }, {})
        row[lookupKey] = consolidatedLookup
      }
      return consolidatedLookup
    },
    questionLookup (row, answers, _buildKey) {
      const lookupKey = _buildKey('__questionLookup')
      var questionLookup = row[lookupKey]
      if (!questionLookup) {
        questionLookup = answers.reduce((a, answer) => {
          a[_buildKey(answer.question)] = {
            value: answer.value,
            total: 1,
            fromList: answer.fromList ? 1 : 0
          }
          return a
        }, {})
        row[lookupKey] = questionLookup
      }
      return questionLookup
    },
    aggregateCosts (aggregate, eventCostName, count) {
      if (!eventCostName) return aggregate
      var costAggregate = aggregate.find(ca => ca.name === eventCostName)
      if (!costAggregate) {
        costAggregate = {
          name: eventCostName,
          total: 0
        }
        aggregate.push(costAggregate)
      }
      costAggregate.total += count
      return aggregate
    },
    consolidateCosts (details) {
      const lookup = {}
      return details
        .reduce((a, d) => {
          const key = d.eventCostName
          if (!d.waitlist && key) {
            var count = lookup[key]
            if (!count) {
              count = {
                name: d.eventCostName,
                total: 0
              }
              lookup[key] = count
              a.push(count)
            }
            count.total++
          }
          return a
        }, [])
    },
    aggregateColumn (aggregate, key, count) {
      if (!key) return aggregate
      var mTypeAggregate = aggregate.find(ca => ca.name === key)
      if (!mTypeAggregate) {
        mTypeAggregate = {
          name: key,
          total: 0
        }
        aggregate.push(mTypeAggregate)
      }
      mTypeAggregate.total += count
      return aggregate
    },
    consolidateColumn (details, columnName) {
      const lookup = {}
      return details
        .reduce((a, d) => {
          const key = d[columnName]
          if (key) {
            var count = lookup[key]
            if (!count) {
              count = {
                name: key,
                total: 0
              }
              lookup[key] = count
              a.push(count)
            }
            count.total++
          }
          return a
        }, [])
    },
    groupDetailColumns (details, columnName) {
      const lookup = {}
      return details
        .reduce((a, d) => {
          const value = d[columnName]
          if (value !== undefined && value !== null && value.length) {
            if (!lookup[value]) {
              a.push(value)
              lookup[value] = true
            }
          }
          return a
        }, [])
    },
    getNameListFromDetails (item, index, items) {
      // Get items remaining in report
      const nextDetails = items.slice(index)
      const reservationDetails = []
      // Of remaining items, get those that are port of the same reservation in item
      for (let i = 0, l = nextDetails.length, n; i < l; i++) {
        n = nextDetails[i]
        if (this.reservationChanged(n, i, nextDetails) || this.isNonDiscretePlusN(n)) break
        reservationDetails.push(n)
      }
      // Extract names from list
      const result = []
      var prevName
      var name
      var dgtn
      for (let detail of reservationDetails) {
        name = this.getNameFromItem(detail)
        dgtn = detail.guestTypeName
        if (!prevName || name !== prevName.name || dgtn !== prevName.guestType) {
          prevName = {
            name: name,
            guestType: dgtn || null,
            count: 1
          }
          result.push(prevName)
        } else {
          prevName.count++
        }
      }
      return result
    },
    getNameFromItem (item) {
      var result = item.name
      if (this.isNonDiscreteRoot(item)) {
        result = (result || (item.guestTypeName ? '' : '???')) + ' + ' + (item.covers - 1)
      }
      return result
    },
    isNonDiscretePlusN (item) {
      return !item.discreteCovers && item.pos > 0
    },
    isNonDiscreteRoot (item) {
      return !item.discreteCovers && item.pos === 0
    },
    countEventCost (item, eventCostLookup, eventCostCounts) {
      if (item.waitlist) return
      const key = item.eventCostName || '' // '' will be our key for 'None'
      var eventCostAccumulator = eventCostLookup[key]
      if (!eventCostAccumulator) {
        eventCostAccumulator = {
          id: key,
          name: item.eventCostName || 'None',
          total: 0
        }
        eventCostCounts.push(eventCostAccumulator)
        eventCostLookup[key] = eventCostAccumulator
      }
      eventCostAccumulator.total++
    },
    commandFilter (c) {
      c.resultFilter = (data) => {
        const countEventCosts = this.eventCostCounts
        const eventCostCounts = []
        const eventCostLookup = {}
        // Init counts for reservations
        var reserveeCount = 0
        var noShowCount = 0
        var reservationCount = 0
        var waitlistedReservees = 0
        var waitlistedReservations = 0
        if (this.groupedByReservation) {
          // Make sure all results are grouped by reservation
          const reservationGroups = {}
          const primaryReservees = []
          // Create list of primary reservees (first reservee)
          // and create map of reservees grouped by reservation
          for (let i = 0, l = data.length, item, group, id; i < l; i++) {
            item = data[i]
            id = item.reservationId
            if (item.pos === 0) {
              // Master reservation
              primaryReservees.push(item)
              if (item.waitlist) {
                waitlistedReservations++
              } else {
                reservationCount++
              }
            }
            group = reservationGroups[id]
            if (!group) {
              group = []
              reservationGroups[id] = group
            }
            group.push(item)
            if (countEventCosts) this.countEventCost(item, eventCostLookup, eventCostCounts)
          }
          this.reservationCount = reservationCount
          this.waitlistedReservations = waitlistedReservations
          // Consolidate list of reservees, grouped by reservation, with each group ordered by position in reservation
          const groupedByReservee = primaryReservees.reduce((result, item) => {
            let group = reservationGroups[item.reservationId].sort((a, b) => a.pos - b.pos)
            if (!item._related) Object.defineProperty(item, '_related', {value: undefined, writable: true})
            item._related = group
            result.push(...group)
            // Reservee count is the covers from primaryReservees
            if (item.waitlist) {
              waitlistedReservees += item.covers
            } else {
              reserveeCount += item.covers - item.noShows
              noShowCount += item.noShows
            }
            return result
          }, [])
          this.reserveeCount = reserveeCount
          this.noShowCount = noShowCount
          this.waitlistedReservees = waitlistedReservees
          // Save any event cost count
          if (countEventCosts) this.eventCostCounts = eventCostCounts
          // return grouped by reservation data
          return this.groupReport(groupedByReservee)
        } // end if groupedByReservation
        // Get reservation count
        const foundIds = []
        this.reservationCount = data.reduce((a, rd) => {
          if (!foundIds[rd.reservationId]) {
            if (rd.waitlist) {
              waitlistedReservations++
              waitlistedReservees += rd.covers
            } else {
              a++
              reserveeCount += rd.covers - rd.noShows
              noShowCount += rd.noShows
            }
            foundIds[rd.reservationId] = true
          }
          if (countEventCosts) this.countEventCost(rd, eventCostLookup, eventCostCounts)
          return a
        }, 0)
        this.reserveeCount = reserveeCount
        this.noShowCount = noShowCount
        this.waitlistedReservations = waitlistedReservations
        this.waitlistedReservees = waitlistedReservees
        // Save any event cost count
        if (countEventCosts) this.eventCostCounts = eventCostCounts
        // return un-grouped data
        return this.groupReport(data)
      }
      return c
    }
  },
  beforeMount () {
    this.setPastEventMoment()
  },
  watch: {
    pastEventMoment (val) {
      console.log('Change pastEventMoment', val)
    },
    selectedEventFilterDate (val, oldVal) {
      // console.log('Resetting date pre-select from date change', val, this.reportFilters.dates)
      this.didEventFilterDateSelect = false
      console.warn('filtering dates a', this.reportFilters.dates, this.reportFilters.date)
      if (!val && oldVal) {
        // Remove date from select list
        this.reportFilters.dates = this.reportFilters.dates && this.reportFilters.dates.filter(d => !moment(d).isSame(oldVal, 'day')) || null
      }
      console.warn('filtering dates b', this.reportFilters.dates, this.reportFilters.date)
    },
    selectedEventNames: {
      handler (val) {
        setTimeout(() => {
          console.log('selectedEventNames', this.selectedEventNames, this.groupedEventsDateList)
          const selectedDate = this.reportFilters.date
          if (val && !val[0]) {
            // console.log('Resetting date pre-select from event clear', val, selectedDate, this.reportFilters.dates)
            this.didEventFilterDateSelect = true
          }
          if (!selectedDate || !val || !val[0] || !this.reportFilters.dates || this.reportFilters.dates[0] || this.didEventFilterDateSelect) {
            // console.log('Skipping date pre-select', val, selectedDate, this.reportFilters.dates)
            return
          }
          // console.log('Doing date pre-select', val, selectedDate, this.selectedEventsDateList, this.reportFilters.dates)
          this.didEventFilterDateSelect = true
          const foundDate = this.selectedEventsDateList.find(d => moment(d.value).isSame(selectedDate, 'day'))
          if (foundDate) {
            this.reportFilters.dates.push(foundDate.value)
          } else {
            // console.log('Cant find date', selectedDate, this.selectedEventsDateList)
          }
        }, 0)
      },
      deep: true
    }
  }
}
